import { RVProperty } from "@10x/rentalvaluation/api/Property";
import { ServerDate } from "@eres/core";
import { LVStrings } from "@my-dld/assets/strings";
import { Lookup } from "@eres/ejari-api/Entity";
import { RVLookup } from "@10x/rentalvaluation/api/api";

export enum HTRequestType {
	HANDOVER = 1,
	TAKEOVER = 2,
}

export enum HTRoleType {
	OWNER = 1,
	TENANT = 5,
}

export const YES: Lookup = {
	Id: 1,
	...LVStrings.yes,
};

export const NO = {
	Id: 0,
	...LVStrings.no,
};

export const YesNo = [ YES, NO ];

export interface HTLookup {
	Identity?: number;
	NameAr?: string;
	NameEn?: string;
}

export interface HTDocLookup extends HTLookup {
	IsMandatory: 0 | 1,
	MaxPages: number;
	MaxSizeKb: number;
	docs?: HTAttachment[];
}

export interface HTParty {
	Email: string;
	EmiratesId: string;
	Identity: number;
	IsEjariUser: number;
	IsOwnerCompany: boolean;
	LicenseNumber: string;
	ManagementCompId: number;
	MangementCompNameAr: string;
	MangementCompNameEn: string;
	MobileNumber: string;
	PartNameAr: string;
	PartNameEn: string;
	ParticipantId: number;
	RequestId: number;
	RoleId: number;
	TenantId: number;
	UnifiedIdNumber: string;
	UserAccountId: number;
	UserProfileId: number;
}

export interface HTProperty extends RVProperty {
	BuildingCards: number;
	FurnishingStatusId: number;
	PropertyConditionId?: number;
	UnitKeys: string;
}

export interface PossibleErrorResponse {
	Error?: RVLookup[];
}

export interface HTRequest extends PossibleErrorResponse {
	Identity: number;
	RequestNumber?: string;
	IsUnitDamaged: boolean;
	ContractNumber: string;
	Notes: string;
	PaidSecurityDeposit?: number;
	ParticipantId: number;
	FinalizedRequirements: HTLookup[];
	Parties: HTParty[];
	Properties: HTProperty[];
	RejectReason?: string;
	RejectReasonDocuments?: HTAttachment[];
	RequestChannelId: number;
	RequestStatusId: number;
	RequestStatusNameAr: string;
	RequestStatusNameEn: string;
	RequestTypeId: number;
	RequestedOn: ServerDate;
	TenancyContractId: number;
	UserAccountId: number;
	Damages?: HTDamage[];
	RequestHistory?: HTRequestHistory[];
	HandoverRequestAttachments?: HTAttachment[];
}

export interface HTDamage {
	DamageAttachments?: HTAttachment[];
	Description?: string;
	Identity?: number;
}

export interface HTAttachment {
	ActualSizeKb?: number;
	DocumentId?: number;
	FileUrl?: string;
	Identity?: number;
	ParentObjectId?: number;
	PhysicalName?: string;
	TemporaryRequestId?: number;
	LocalData?: string;
	UploadDate?: string;
}

export interface HTRequestHistory {
	CreatedByAr: string;
	CreatedByEn: string;
	CreationDate: string;
	Notes: string;
	ParticipantId: number;
	RequestId: number;
	RequestNumber: string;
	RequestStatusId: number;
	RequestStatusNameAr: string;
	RequestStatusNameEn: string;
	TenantId: number;
	RoleId: number;
}

export interface HTRequestResponse extends PossibleErrorResponse {
	Error: RVLookup[];
	IsSuccess: boolean;
	Message: string;
	RequestId: number;
	RequestNumber: string;
}

export interface HTCountRequest {
	participantId?: number;
	tenantId?: number;
}

export interface HTCountResponse extends PossibleErrorResponse {
	RequestCount: number;
	RequestCountFromOwner: number;
}

export interface HTSearchRequest {
	PageIndex: number;
	PageSize: number;
	ParticipantId?: number;
	RoleId: number;
	TenantId?: number;
}

export interface HTSearchResponse extends PossibleErrorResponse {
	TotalRecords: number;
	IsSuccess: boolean;
	Data: HTRequestItem[];
}

export interface HTRequestItem {
	AreaNameAr: string;
	AreaNameEn: string;
	ContractNumber: string;
	PropertyNumber: string;
	RequestNumber: string;
	RequestChannelId: number;
	RequestId: number;
	RequestStatusId: number;
	RequestTypeId: number;
	RequestStatusNameAr: string;
	RequestStatusNameEn: string;
	RequestedOn: string;
}

export enum HTRequestStatus {
	DRAFT = 1,
	SUBMITTED = 2,
	REJECTED = 3,
	ACCEPTED = 4,
	CANCELLED = 5,
}

export interface HTValidatePropertyRequest {
	IsFreeHold: number;
	PropertyId: number;
	PropertyTypeId: number;
	ServiceCode: EjariServiceCode;
}

export enum EjariServiceCode {
	RENTAL_VALUATION = 0,
	REGISTER_PROPERTY = 1,
	HANDOVER = 2,
	TAKEOVER = 3
}

export interface HTActionRequest {
	ActionByPartId?: number;
	ActionByTenantId?: number;
	RejectReason?: string;
	RejectReasonAttachments?: HTAttachment[];
	RequestId?: number;
	RequestStatusId: number;
}
